import { containerFrom } from '../../styles/container';
import { makeStyles } from '../../styles/themes/themewrapper';

export const FLIGHT_SELECTOR_NAME = 'flightSelector';
export const FLIGHT_SELECTOR_SIZE = 720;
export const FLIGHT_SELECTOR_SIZE_LG = 820;

export const useCustomStyles = makeStyles<void, 'selectionHeader'>()((theme, _, classes) => ({
	flightSelectorWrapper: {
		border: theme.divider.border,
		borderRadius: theme.borderRadius.rounded,
		display: 'flex',
		flexDirection: 'column',

		'&:hover': {
			cursor: 'pointer',

			[`.${classes.selectionHeader}`]: {
				background: theme.palette.neutral[5],
			},
		},

		'&:has(:focus-visible)': {
			border: theme.flightSelection.border.focus,
			boxShadow: theme.flightSelection.focus,
		},
	},

	selectionHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: theme.spacing.small,
		borderBottom: theme.divider.border,
	},

	selectionFooter: {
		display: 'flex',
		padding: theme.spacing.small,
		gap: theme.spacing.small,
		borderTop: theme.divider.border,
	},

	flightsContainer: {
		padding: theme.spacing.small,
	},

	labels: {
		display: 'flex',
		gap: theme.spacing.tiny,
		flexWrap: 'wrap',
		justifyContent: 'flex-end',
		flexDirection: 'row',
	},

	inclusives: {
		[containerFrom(FLIGHT_SELECTOR_SIZE, FLIGHT_SELECTOR_NAME)]: {
			alignItems: 'flex-end',
		},
	},
}));
